<template>
  <div>
    <Toolbar class="p-mb-4">
      <template slot="left">
        <Button
          label="Add Lost Quote Note"
          icon="pi pi-plus"
          class="p-button-success p-mr-2"
          @click="openNewTypesForm"
        />
      </template>
      <template slot="right">
        <span class="p-input-icon-left">
          <i class="pi pi-search" />
          <InputText v-model="filters['global']" placeholder="Global Search" />
        </span>
      </template>
    </Toolbar>
    <DataTable
      :value="lqNotes"
      :paginator="true"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      :rows="25"
      dataKey="contactId"
      :filters="filters"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[5, 10, 25]"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} Related Accounts"
    >
      <template #header>
        <div class="table-header">Related Lost Quote Notes.</div>
      </template>

      <template #empty> No Related Lost Quote Notes. Accounts found! </template>
      <template #loading>
        Loading Related Lost Quote Notes. Please wait.
      </template>
      <Column field="id" header="Id" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.id ? slotProps.data.id : "" }}
        </template>
      </Column>
      <Column field="lqNoteCode" header="Display Order" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.lqNoteCode ? slotProps.data.lqNoteCode : "" }}
        </template>
      </Column>
      <Column field="lqNoteDesc" header="Description" :sortable="true">
        <template #body="slotProps">
          {{ slotProps.data.lqNoteDesc ? slotProps.data.lqNoteDesc : "" }}
        </template>
      </Column>
      <Column field="active" header="Active" :sortable="true">
        <template #body="slotProps">
          <span v-if="slotProps.data.active">YES</span>
          <span v-else>NO</span>
        </template>
      </Column>
      <Column headerStyle="width: 10em;">
        <template #body="slotProps">
          <div :style="{ position: 'relative' }">
            <SplitButton
              label="Edit"
              icon="pi pi-pencil"
              class="p-button-success p-mb-2"
              @click="editLqNotes(slotProps.data)"
              :model="getButtons(slotProps.data)"
            >
            </SplitButton>
          </div>
        </template>
      </Column>
    </DataTable>
    <Dialog
      :visible.sync="lqNotesForm"
      :style="{ width: '640px', overflowY: 'auto' }"
      header="Lost Quote Note"
      :modal="true"
      class="p-fluid"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field p-col relative">
          <label for="noteHeader">Display Order:</label>
          <InputText
            id="noteHeader"
            v-model.trim="lqNote.lqNoteCode"
            required="true"
            autofocus
          />
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field p-col">
          <label for="noteDetails">Description:</label>
          <InputText
            placeholder=""
            :disabled="false"
            :autoResize="true"
            rows="6"
            v-model="lqNote.lqNoteDesc"
          />
        </div>
        <div class="p-field p-col">
          <label for="noteDetails">Active:</label>
          <SelectButton
            v-model="lqNote.active"
            :options="options"
            optionLabel="label"
            optionValue="value"
          />
        </div>
      </div>
      <template #footer>
        <Button
          label="Cancel"
          icon="pi pi-times"
          class="p-button-text"
          @click="lqNotesForm = false"
        />
        <Button
          label="Save"
          icon="pi pi-check"
          class="p-button-text"
          @click="save"
        />
      </template>
    </Dialog>
    <Dialog
      header="Confirmation"
      :visible.sync="displayConfirmation"
      :style="{ width: '350px', overflowY: 'auto' }"
      :modal="true"
    >
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>Do you wish to delete the Lost Quote Note?</span>
      </div>
      <template #footer>
        <Button
          label="No"
          icon="pi pi-times"
          @click="closeConfirmation"
          class="p-button-text"
        />
        <Button
          label="Yes"
          icon="pi pi-check"
          @click="deleteLqNotes"
          class="p-button-text"
          autofocus
        />
      </template>
    </Dialog>
  </div>
</template>

<script>
import QuotationService from "@/service/QuotationService";
import PermissionMixin from "../PermissionMixin.vue";
export default {
  mixins: [PermissionMixin],
  quotationService: null,
  data: () => ({
    lqNotesForm: false,
    displayConfirmation: false,
    loading: true,
    filters: {},
    lqNotes: null,
    lqNote: {},
    options: [
      { value: true, label: "yes" },
      { value: false, label: "no" }
    ]
  }),
  methods: {
    getButtons(data) {
      this.checkPermissions();
      let buttons = [];
      if (this.deleteSettings) {
        buttons.push({
          label: "Delete",
          icon: "pi pi-trash",
          command: () => {
            this.openConfirmation(data);
          }
        });
      }
      return buttons;
    },
    openNewTypesForm() {
      this.lqNote = {};
      this.lqNotesForm = true;
    },
    openConfirmation(data) {
      this.lqNote = data;
      this.displayConfirmation = true;
    },
    closeConfirmation() {
      this.displayConfirmation = false;
    },
    editLqNotes(data) {
      this.lqNote = data;
      this.lqNotesForm = true;
    },
    async deleteLqNotes() {
      this.closeConfirmation();
      await this.quotationService.deleteLostQuoteNotes(this.lqNote.id);
      this.$toast.add({
        severity: "success",
        summary: "Success Message",
        detail: "Lost Quote Note removed",
        life: 5000
      });
      this.getAllLostQuoteNotes();
      this.getLostStatusReasonsByHard();
    },
    save() {
      if (!this.lqNote.id) {
        this.quotationService
          .postLostQuoteNotes(this.lqNote)
          .then(res => {
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Lost Quote Note added",
              life: 5000
            });
            this.getAllLostQuoteNotes();
            this.getLostStatusReasonsByHard();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while saving lost quote note",
              life: 5000
            });
          });
      } else {
        this.quotationService
          .putLostQuoteNotes(this.lqNote, this.lqNote.id)
          .then(res => {
            this.$toast.add({
              severity: "success",
              summary: "Success Message",
              detail: "Lost Quote Note updated",
              life: 5000
            });
            this.getAllLostQuoteNotes();
            this.getLostStatusReasonsByHard();
          })
          .catch(err => {
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Error while updating lost quote note",
              life: 5000
            });
          });
      }
      this.lqNotesForm = false;
    },
    getAllLostQuoteNotes() {
      this.loading = true;

      this.quotationService
        .getAllLostQuoteNotesByHard()
        .then(data => {
          this.loading = false;
          this.lqNotes = data;
        })
        .catch(err => {
          // this.$toast.add({
          //   severity: "error",
          //   summary: "Error",
          //   detail: "Error while getting lost quote notes",
          //   life: 5000,
          // })
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "lostquotenotes"'
          });
        });
    },
    getLostStatusReasonsByHard() {
      this.quotationService
        .getLostStatusReasonsByHard()
        .then(data => {})
        .catch(err => {
          this.$store.dispatch("addErrorMessage", {
            severity: "error",
            content: 'Some data was not loaded from "activeLostQuoteNotes"'
          });
        });
    }
  },
  created() {
    this.quotationService = new QuotationService();
  },
  mounted() {
    this.getAllLostQuoteNotes();
  }
};
</script>
